import '../libs/jsencrypt'
import _ from 'lodash'
import ajax from '@/libs/ajax'

// 公共正则
export const regExp = {
  phone: /^1[3-9]\d{9}$/,
  mail: /^[a-zA-Z0-9]+([-|_|.]?[a-zA-Z0-9])*@([a-zA-Z0-9]+(-[a-zA-Z0-9]+)?\.)+[a-zA-Z]{2,}$/,
  corpName: /^.{1,80}$/,
  userName: /^([\u4E00-\u9FA5a-zA-Z]{1,40}(·[\u4E00-\u9FA5]{1,40})?$)|([a-zA-Z]{1,40}(\s[a-zA-Z]{1,20})+$)/,
  newPassword:/^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{8,20}$/
}
export const forEach = (arr, fn) => {
  if (!arr.length || !fn) return
  let i = -1
  let len = arr.length
  while (++i < len) {
    let item = arr[i]
    fn(item, i, arr)
  }
}
// 节流函数
export const debounce = (fn, delay = 200) => {
  let timer
  return function () {
    let context = this
    let args = arguments
    clearTimeout(timer)
    timer = setTimeout(function () {
      fn.apply(context, args)
    }, delay)
  }
}
// 获取公钥key
export const getPublicKey = () => {
  return ajax.get('/v1/auth/passwords/public-keys').then((data) => {
      if (data.code === '0') {
          return data.data
      } else {
          return ''
      }
  })
}

// 用公钥对密码加密
export const encryptPwd = (publicKey, password) => {
  let JSEncrypt = window.JSEncrypt
  let encrypt = new JSEncrypt()

  encrypt.setPublicKey(publicKey)
  return encrypt.encryptLong(password)
}

export const cookie = {
  add(name, value, iDay, domain) {
      if (!iDay) return
      let oDate = new Date()
      oDate.setDate(oDate.getDate() + iDay)
      document.cookie =
          name +
          '=' +
          value +
          ';path=/;expires=' +
          oDate.toGMTString() +
          ';domain=' +
          domain
  },
  get(name) {
      let cookies = document.cookie.split('; ')
      for (let i = 0, len = cookies.length; i < len; i++) {
          let arr = cookies[i].split('=')
          if (arr[0] === name) return arr[1]
      }
      return ''
  },
  del(name) {
      document.cookie = name + '=;path=/;expires=' + new Date(0).toGMTString()
  }
}

// 判断浏览器
export const navJudge = () => {
  let userAgent = navigator.userAgent
  let isOpera = userAgent.indexOf('Opera') > -1 // 判断是否Opera浏览器
      // isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera, //判断是否IE浏览器
  let isIE = userAgent.indexOf('MSIE') > -1 && !isOpera // 判断是否IE浏览器
  let isEdge = userAgent.indexOf('Windows NT 6.1; Trident/7.0;') > -1 && !isIE // 判断是否IE的Edge浏览器
  let isFF = userAgent.indexOf('Firefox') > -1 // 判断是否Firefox浏览器
  let isSafari = userAgent.indexOf('Safari') > -1 && userAgent.indexOf('Chrome') === -1 // 判断是否Safari浏览器
  let isChrome = userAgent.indexOf('Chrome') > -1 && userAgent.indexOf('Safari') > -1 // 判断Chrome浏览器
  let isIE11 = userAgent.toLowerCase().indexOf('trident') > -1 && userAgent.indexOf('rv:11.0') > -1
  if (isIE) {
      let reIE = new RegExp('MSIE (\\d+\\.\\d+);')
      reIE.test(userAgent)
      let IEVersion = parseFloat(RegExp['$1'])
      if (IEVersion === 7) {
          return 'isIE7'
      } else if (IEVersion === 8) {
          return 'isIE8'
      } else if (IEVersion === 9) {
          return 'isIE9'
      } else if (IEVersion === 10) {
          return 'isIE10'
      } else {
          return '0' // IE版本<=7
      }
  }
  if (isIE11) {
      return 'isIE11'
  }
  if (isFF) {
      return 'isFF'
  }
  if (isOpera) {
      return 'isOpera'
  }
  if (isSafari) {
      return 'isSafari'
  }
  if (isChrome) {
      return 'isChrome'
  }
  if (isEdge) {
      return 'isEdge'
  }
}
// 时间输入框限制输入
export const disableTimeInput = (time, type) => {
  // 使用方法：
  // 开始时间time为结束时间字段，type为1，
  // 结束时间time为开始时间字段，type为2.
  // 引入页面需要return 此方法
  return {
      disabledDate: date => {
          if (time) {
              if (type === 1) {
                  return date && date.valueOf() > new Date(time).valueOf();
              } else if (type === 2) {
                  return date && date.valueOf() < new Date(time).valueOf() - 86400000;
              }
          } else {
              return false
          }
      }
  }
}
// 日期格式化
export const dateFormat = (value, format = 'yyyyMMdd') => {
  let date = _.isNumber(value) ? new Date(value) : _.isDate(value) ? value : undefined
  if (date === undefined) {
    return value
  }
  let o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return format
}